import notificationsTabTemplate from '@/notifications/layout/notificationsTabTemplate';

export default notificationsTabTemplate(
  ['datasets'],
  ({ datasets }, { isGuest }) => datasets.read && !isGuest,
  'dataset',
);
